// permissionData.ts or permissionData.js
const permissionData = {
	dashboard: { create: false, edit: false, read: false, delete: false },
	profile: { create: false, edit: false, read: false, delete: false },
	category: { create: false, edit: false, read: false, delete: false },
	products: { create: false, edit: false, read: false, delete: false },
	order: { create: false, edit: false, read: false, delete: false },
	wholesale: { create: false, edit: false, read: false, delete: false },
	productEnquiry: { create: false, edit: false, read: false, delete: false },
	coupon: { create: false, edit: false, read: false, delete: false },
};

export default permissionData;
